// Package Imports
import PageSkeleton from '@/core/components/page-skeleton'
import RouteError from '@/core/components/route-error'
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'

// Core Imports
import { queryClient } from '@/core/lib/query-client'
import { toAdminListParams } from '@/core/lib/table-query'

// External Module Imports
import { dashboardRoute } from '@/modules/dashboard/dashboard.routes'

// Module Imports
import {
  individualAchievementDetailQueryOptions,
  individualAchievementListQueryOptions,
} from '@/modules/individual-achievement/individual-achievement.hooks'
import { individualAchievementSearchSchema } from '@/modules/individual-achievement/individual-achievement.schemas'

export const individualAchievementRoute = createRoute({
  path: '/individual-achievements',
  getParentRoute: () => dashboardRoute,
  errorComponent: ({ error, reset }) => (
    <RouteError error={error} reset={reset} />
  ),
})

export const individualAchievementListRoute = createRoute({
  getParentRoute: () => individualAchievementRoute,
  path: '/',
  head: () => ({
    meta: [{ title: 'Bireysel Başarımlar' }],
  }),
  validateSearch: individualAchievementSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ deps }) => {
    await queryClient.ensureQueryData(
      individualAchievementListQueryOptions(toAdminListParams(deps))
    )
  },
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () =>
      import('@/modules/individual-achievement/pages/list-individual-achievement.page')
  ),
})

export const individualAchievementCreateRoute = createRoute({
  getParentRoute: () => individualAchievementRoute,
  path: '/create',
  head: () => ({
    meta: [{ title: 'Bireysel Başarım Oluştur' }],
  }),
  component: lazyRouteComponent(
    () =>
      import('@/modules/individual-achievement/pages/create-individual-achievement.page')
  ),
})

export const individualAchievementDetailRoute = createRoute({
  getParentRoute: () => individualAchievementRoute,
  path: '/$id',
  head: () => ({
    meta: [{ title: 'Bireysel Başarım Detayı' }],
  }),
  loader: async ({ params: { id } }) => {
    await queryClient.ensureQueryData(
      individualAchievementDetailQueryOptions(id)
    )
  },
  pendingComponent: () => <PageSkeleton />,
  pendingMs: 100,
  component: lazyRouteComponent(
    () =>
      import('@/modules/individual-achievement/pages/detail-individual-achievement.page')
  ),
})

export const individualAchievementEditRoute = createRoute({
  getParentRoute: () => individualAchievementRoute,
  path: '/$id/edit',
  head: () => ({
    meta: [{ title: 'Bireysel Başarım Düzenle' }],
  }),
  component: lazyRouteComponent(
    () =>
      import('@/modules/individual-achievement/pages/edit-individual-achievement.page')
  ),
})
